import React, { useEffect, useState } from "react";
import {
  Avatar,
  Button,
  Input,
  Form, Spin, Col, Image, message
} from "antd";
import {
  PlusOutlined, DeleteOutlined
} from "@ant-design/icons";
import UserIcon from "../../../../../../assets/images/icons/userLogo.svg";
import { useLocation } from "react-router-dom";
import { useStore } from "../../../../../../store";
import { aboutUSkeys } from "../../../../../../config";
import { useTab } from "../../../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../../../utils";

const { TextArea } = Input;
const MAX_CHARACTERS = 500;

export default function AccreditationComponent({
  dataLoader,
  form,
  activeKey,
}) {
  const { state } = useLocation();
  const tabKey = state;
  const { tabData } = useStore();
  const whichTab = aboutUSkeys.Accreditation;
  const { updateAccreditationImage } = useConnectsuForm();
  const [loader, setLoader] = useState(true);
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();
  const { deleteSingleItem, postLoader, getSingleTabData, dataLoader: tabDataLoader } = useTab();

  // New state to track unsaved items
  const [hasUnsavedItem, setHasUnsavedItem] = useState(false);
  const [canAddNew, setCanAddNew] = useState(true);

  if (activeKey === "ABOUT_US") {
    localStorage.setItem("tab", activeKey);
  }

  useEffect(() => {
    setFormChanged(false);
    setCanAddNew(true);
  }, []);

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;
    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);



  const renderMedia = (dataItem) => {
    const commonStyles = {
      width: "350px",
      height: "250px",
      display: "flex",
      justifyContent: "center",
    };

    const imageUrl =
      dataItem?.awardsLogos?.url || // accreditation image from form state
      dataItem?.mediaLink?.url ||   // fallback (about us team style)
      dataItem?.aboutUsTeamDataOutPut?.image?.url; // backend state fallback

    if (imageUrl) {
      return (
        <div className="iframe-comp" style={commonStyles}>
          <img
            src={imageUrl}
            alt=""
            className="c1 carousel-image"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        </div>
      );
    }

    return null;
  };

  const findValue = (i, key) => {
    return getFormFieldValue(form, whichTab, i, key);
  };

  const handleAddMore = () => {
    if (!canAddNew) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    const currentList = form.getFieldValue(whichTab) || [];

    const unsavedItem = currentList.find(item => {
      const hasData =
        item?.title?.trim() ||
        item?.description?.trim() ||
        item?.awardsLogos?.url ||
        item?.awardsLogos?.name;
      return !item?.id && hasData;
    });

    if (unsavedItem) {
      message.warning("You must save the current item before you can add a new one.");
      return;
    }

    // ✅ Prepend new empty row at the top
    const newList = [{}, ...currentList];
    form.setFieldsValue({ [whichTab]: newList });

    setCanAddNew(false);
    setHasUnsavedItem(true);
  };

  const handleSave = () => {
    form.submit();
    setTimeout(() => {
      setCanAddNew(true);
      setHasUnsavedItem(false);
    }, 500);
  };

  const refreshUnsavedState = () => {
    const currentList = form.getFieldValue(whichTab) || [];
    const unsavedItem = currentList.find(item =>
      !item?.id &&
      (item?.title?.trim() || item?.description?.trim() || item?.awardsLogos?.url)
    );
    setCanAddNew(!unsavedItem);
    // setHasUnsavedItem(!!unsavedItem);
  };

  const handleClear = () => {
    const currentList = form.getFieldValue(whichTab) || [];

    // Reset unsaved row(s)
    const updatedList = currentList.map(item =>
      !item?.id ? { title: "", description: "", awardsLogos: { name: "", url: "" } } : item
    );

    form.setFieldsValue({ [whichTab]: updatedList });

    // Unlock if no unsaved items
    const unsavedItem = updatedList.find(item =>
      !item?.id &&
      (item?.title?.trim() || item?.description?.trim() || item?.awardsLogos?.url)
    );

    setCanAddNew(!unsavedItem);
    // setHasUnsavedItem(!!unsavedItem);

    refreshUnsavedState()
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tabData?.ACCREDITATIONS_AWARDS?.length === 0) {
        setHasUnsavedItem(true);
      } else {
        setHasUnsavedItem(false);
      }
    }, 500);

    return () => clearTimeout(timer); // cleanup for safety
  }, [tabData?.ACCREDITATIONS_AWARDS]);


  const handleDelete = (whichTab, form, i, tabKey) => {
    const item = form.getFieldValue(whichTab)?.[i];
    const id = item?.id;

    if (id) {
      // Delete from backend
      deleteSingleItem(whichTab, id, form);
    } else {
      // Just remove from form (unsaved/new row)
      const currentList = form.getFieldValue(whichTab) || [];
      currentList.splice(i, 1);
      form.setFieldsValue({ [whichTab]: currentList });
    }


    setTimeout(() => {
      const currentList = form.getFieldValue(whichTab) || [];
      const unsavedItem = currentList.find(item =>
        !item?.id &&
        (item?.title?.trim() || item?.description?.trim() || item?.awardsLogos?.url)
      );

      setCanAddNew(!unsavedItem);
      setHasUnsavedItem(!!unsavedItem);
      refreshUnsavedState()
    }, 100);
  };

  useEffect(() => {
    form.resetFields();
    refreshUnsavedState();
    setTimeout(() => {
      setLoader(false);
      setCanAddNew(true);
    }, 1000);
  }, [tabData[whichTab]]);

  if (dataLoader || postLoader || loader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div>
        <div style={{ display: "flex" }}>
          {tabKey.split("/")[1] === whichTab ? (
            <>
              <div className="w-100">
                <Form.List
                  name={whichTab}
                  initialValue={
                    tabData &&
                      tabData[whichTab] &&
                      tabData[whichTab].length > 0
                      ? tabData[whichTab]
                      : [{}]
                  }
                >
                  {(fields, { add, remove }) => (
                    <div
                      className="w-100"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      <div className="inputBody w-100">
                        <div style={{ textAlign: "right" }}>
                          {hasUnsavedItem && (
                            <Button
                              className="cancelBtn"
                              type="button"
                              // disabled={!formChanged}   // Only enable if editing started
                              onClick={handleClear}
                            >
                              Clear
                            </Button>
                          )}
                          <Button
                            className="greenBtn"
                            onClick={handleAddMore}
                          >
                            Add <PlusOutlined />
                          </Button>
                        </div>
                      </div>
                      {fields.map(({ key, name, ...restField }, i) => {
                        const formItem =
                          form.getFieldValue([whichTab, i]) || {};
                        const backendItem = tabData[whichTab]?.[i];
                        const hasTitle =
                          (formItem.title &&
                            formItem.title.trim() !== "") ||
                          (backendItem &&
                            backendItem.title &&
                            backendItem.title.trim() !== "");
                        const hasId = backendItem && backendItem.id;
                        return (
                          <div key={i} className="card-item">
                            <Col
                              className="gutter-row tabContent"
                              span={16}
                              style={{ paddingRight: "25px" }}
                            >
                              <div style={{ display: "flex" }}>
                                <Form.Item
                                  className="w-100"
                                  {...restField}
                                  label="Name/Title"
                                  name={[name, "title"]}
                                  labelCol={{ span: 5 }}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Title is required",
                                    },
                                  ]}
                                >
                                  <Input
                                    placeholder="Enter Title"
                                    maxLength={40}
                                    showCount={{
                                      formatter: ({ count }) => `${count}/40`,
                                    }}
                                    onKeyDown={(e) => {
                                      const currentValue = form.getFieldValue([whichTab, name, "title"]) || "";

                                      // Ignore control keys
                                      if (
                                        e.key.length === 1 && // only normal characters
                                        currentValue.length >= 40
                                      ) {
                                        form.setFields([
                                          {
                                            name: [whichTab, name, "title"],
                                            errors: ["Title cannot exceed 40 characters"],
                                          },
                                        ]);
                                      }
                                    }}
                                    onBlur={() => {
                                      form.setFields([
                                        {
                                          name: [whichTab, name, "title"],
                                          errors: [],
                                        },
                                      ]);
                                    }}
                                  />
                                </Form.Item>
                                <div
                                  className="remove-btn"
                                  style={{ position: "relative" }}
                                >
                                  <DeleteOutlined
                                    style={{ cursor: "pointer" }}
                                    title="Delete Team"
                                    onClick={() => {
                                      if (hasTitle === false) return;
                                      if (hasId) {
                                        handleDelete(
                                          whichTab,
                                          form,
                                          i,
                                          tabKey
                                        );
                                      } else {
                                        remove(name);
                                        setHasUnsavedItem(false);
                                        refreshUnsavedState();
                                      }
                                      setCanAddNew(true);
                                    }}
                                  />
                                </div>
                              </div>

                              <div style={{ display: "flex" }}>
                                <Form.Item
                                  className="w-100"
                                  label="Description"
                                  {...restField}
                                  labelCol={{ span: 5 }}
                                  name={[name, "description"]}
                                  rules={[
                                    {
                                      required: true,
                                      message: "Description is required",
                                    },
                                    {
                                      max: MAX_CHARACTERS - 1,
                                      message: `Description should be less than ${MAX_CHARACTERS} character`,
                                    },
                                  ]}
                                >
                                  <TextArea
                                    placeholder="Enter Description"
                                    rows={5}
                                    maxLength={MAX_CHARACTERS}
                                    showCount
                                  />
                                </Form.Item>
                              </div>
                              <Form.Item
                                {...restField}
                                label="Accreditation"
                                colon={false}
                                name="awardsLogos.name"
                                className="experienceImg uploadedImage"
                                labelCol={{ span: 5 }}
                              >
                                {findValue(i, "blob") ? (
                                  <Image
                                    src={URL.createObjectURL(
                                      findValue(i, "blob")
                                    )}
                                    alt=""
                                  />
                                ) : form.getFieldValue(whichTab)[i]
                                  ?.awardsLogos?.url ? (
                                  <Image
                                    src={
                                      form.getFieldValue(whichTab)[i]
                                        .awardsLogos.url
                                    }
                                    alt=""
                                  />
                                ) : (
                                  <Image src={UserIcon} alt="" />
                                )}
                                <div>

                                  <label
                                    name="file"
                                    className="fileUploadBtn greenBtn"
                                  >
                                    {" "}
                                    Upload image
                                    <input
                                      accept="image/png, image/gif, image/jpeg"
                                      type="file"
                                      onChange={(e) =>
                                        updateAccreditationImage(
                                          e,
                                          i,
                                          form,
                                          whichTab
                                        )
                                      }
                                    />
                                  </label>
                                  <div style={{ marginLeft: '12px', marginTop: '5px' }} className="">Add or Edit</div>

                                </div>

                              </Form.Item>

                              <Form.Item
                                className="w-100"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                {formChanged ? (
                                  <Button
                                    className="saveBtn greenBtn"
                                    onClick={handleSave}
                                  >
                                    Save
                                  </Button>
                                ) : (
                                  <Button
                                    className="saveBtn greenBtn"
                                    style={{
                                      opacity: "0.5",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    Save
                                  </Button>
                                )}
                              </Form.Item>
                            </Col>
                            <Col className="gutter-row tabContent" span={8}>
                              <div>
                                {form.getFieldValue(whichTab)?.[i]
                                  ?.awardsLogos
                                  ? renderMedia({
                                    mediaLink: {
                                      url: form.getFieldValue(whichTab)[i]
                                        .awardsLogos.url,
                                    },
                                  })
                                  : null}
                              </div>
                            </Col>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </Form.List>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
}